import { Controller } from "@hotwired/stimulus"
// Admin venue form: the kind is a row of chips, the subcategory a row of
// chips per kind. Picking a kind reveals its own subcategory row and clears
// the others, so the form never submits a subcategory from another kind.
export default class extends Controller {
  static targets = ["group"]

  connect() { this.reveal(this.element.querySelector("input[name='venue[kind]']:checked")?.value) }

  pick(event) { this.reveal(event.target.value) }

  reveal(kind) {
    this.groupTargets.forEach((g) => {
      const own = g.dataset.kind === kind
      g.classList.toggle("hidden", !own)
      if (!own) g.querySelectorAll("input[type=radio]").forEach((r) => { r.checked = false })
    })
  }
}
